       
          <!-- ================================================= Tab for HOD and Manager Upcoming Training  ================================================================================ -->

      
          <div class="tabs-container" *ngIf="loggedInUserRole == 'Manager' || loggedInUserRole == 'HOD'">
            <div class="custom-tab-group card p-10">
              <div class="tab-button" 
                   [class.active]="selectedTypeTabName === 'createcalendar'" 
                   (click)="selectTab('createcalendar')">
                <span class="material-icons">calendar_today</span>
               My Upcoming Training
              </div>
              <div class="tab-button" 
                   [class.active]="selectedTypeTabName === 'employeeapproval'" 
                   (click)="selectTab('employeeapproval')">
                <span class="material-icons">how_to_reg</span>
              Team Upcoming Training
              </div>
            </div>
            
            
            
            <div class="card  createcalendar">
        
              <!-- Create calendar -->
               
              <div class="p-10 m-20 createcalendar"  *ngIf="selectedTypeTabName=='createcalendar'">                 
                <div class="cardBox mb-20" >
                  <ion-row class="ion-align-items-center ion-justify-content-start ml-20 pt-20">
        
                    <!-- Year Select -->
                    <ion-col size="12" size-sm="3" class="mb-16">
                      <mat-form-field class="custom-mat-field mat-height40 mat-input-style w-100">
                        <mat-select placeholder="Select Year" [(ngModel)]="selectedYearForCompetency"
                                    (selectionChange)="getYearSetupForReimbursement(selectedYearForCompetency)">
                          <mat-option *ngFor="let item of pmsYears" [value]="item.year">
                            {{ sharedService.transformYearToFyFormat(item.year) }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </ion-col>
                  
                  
                    <!-- Department Multi-select -->
                    <ion-col size="12" size-sm="3" class="mb-16">
                      <ng-multiselect-dropdown
                        class="w-100 mat mat-height40 mat-input-style"
                        [placeholder]="'Select Department'"
                        [settings]="dropdownSettings"
                        [data]="getDepartmentsList"
                        formControlName="department"
                        (onSelect)="onDepartmentSelect()"
                        (onDeSelect)="onDepartmentDeSelect()"
                        (onSelectAll)="onDepartmentAllSelect()"
                        (onDeSelectAll)="onDepartmentAllDeSelect()">
                      </ng-multiselect-dropdown>
                    </ion-col>
                  
                  </ion-row>
        
                  <hr style="border: none; height: 1px; background-color: #cccccc8f;" />
                                  
                 <ion-row class="ion-align-items-center ion-justify-content-between ml-20">
        
                    <!-- Left: Search & Action Buttons -->
                    <ion-col size="12" size-lg="9">
                      <ion-row class="ion-align-items-center">
                  
                        <!-- Search -->
                        <ion-col size="12" size-sm="4" class="mb-16">
                          <mat-form-field class="mat-height40 mat-input-style w-100">
                            <mat-icon matPrefix>search</mat-icon>
                            <input matInput type="search" placeholder="Search" [(ngModel)]="searchTerm" (input)="filterEmployees()">
                          </mat-form-field>
                        </ion-col>
                      </ion-row>
                    </ion-col>
                  
                    <!-- Right: Show Entries + Download -->
                    <ion-col size="12" size-lg="3" class="mb-16">
                      <div class="d-flex justify-content-end align-items-center" style="gap: 10px;">
                       
                        <label>
                          <ion-label class="fs-14 font_regular pr-10 black_color ml-10">Show</ion-label>
                          <mat-form-field class="w70px mat-height40 mat-input-style">
                            <mat-select placeholder="Select" (selectionChange)="DislaySelectedRecord($event)">
                              <mat-option [value]="2">2</mat-option>
                              <mat-option [value]="25">25</mat-option>
                              <mat-option [value]="50">50</mat-option>
                              <mat-option [value]="75">75</mat-option>
                              <mat-option [value]="100">100</mat-option>
                            </mat-select>
                          </mat-form-field>
                          <ion-label class="fs-14 font_regular pl-10 black_color">entries</ion-label>
                        </label>
                  
                        <!-- Download Icon -->
                        <span class="icon-download fs-20 material-icons" style="cursor: pointer;" (click)="downloadEmployeeList()">download</span>
                  
                      </div>
                    </ion-col>
                  
                  </ion-row>
                  
                  
                  <div class="p-10">
                    <ion-row>
                      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                        <div class="table-container">
                          <table class="custom-table rounded-header">
                             <thead>
                              <tr>
                                <ng-container *ngFor="let item of tableHeaders">
                                  <th *ngIf="!item.roles || item.roles.includes(loggedInUserRole)" class="fs-14 font_bold cl-black">
                                    <div class="verticle-center justify-content-space-between icon-style">
                                      {{ item?.label }}
                                    </div>
                                  </th>
                                </ng-container>
                              </tr>                              
                            </thead>
                              <tbody class="bg-white">
                                <tr *ngFor="let program of trainingPrograms">
                                  
                                  <td>{{ program.trainingType }}</td>
                                  <td>{{ program.title }}</td>
                                  <td>{{ program.code }}</td>
                                  <td><a [href]="program.lmsLink" target="_blank">link</a></td>
                                  <td>{{ program.startDate }}</td>
                                  <td>{{ program.endDate }}</td>
                                  <td>{{ program.category }}</td>
                                  <td>{{ program.department }}</td>
                                  <td>{{ program.band }}</td>
                                  <td>{{ program.grade }}</td>
                                  <td>{{ program.programDays }}</td>
                                  <td *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin'">{{ program.budgetCost }}</td>
                                  <td   *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin'">{{ program.actualCost }}</td>
                                  <td>{{ program.objective }}</td>
                     
                                </tr>
                              </tbody>
                          </table>
                        </div>
                      </ion-col>
                    </ion-row>
                  </div>
                </div>
              </div>
        
        
        
        
        
              <!--========================================== Team upcoming Training ==============================================================-->
        
                  
                    <div class="p-10 m-20"   *ngIf="selectedTypeTabName=='employeeapproval'" >                 
                  <div class="cardBox mb-20" >
                    <ion-row class="ion-align-items-center ion-justify-content-start ml-20 pt-20">
        
                      <!-- Year Select -->
                      <ion-col size="12" size-sm="3" class="mb-16">
                        <mat-form-field class="custom-mat-field mat-height40 mat-input-style w-100">
                          <mat-select placeholder="Select Year" [(ngModel)]="selectedYearForCompetency"
                                      (selectionChange)="getYearSetupForReimbursement(selectedYearForCompetency)">
                            <mat-option *ngFor="let item of pmsYears" [value]="item.year">
                              {{ sharedService.transformYearToFyFormat(item.year) }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </ion-col>
                    
                    
                      <!-- Department Multi-select -->
                      <ion-col size="12" size-sm="3" class="mb-16">
                        <ng-multiselect-dropdown
                          class="w-100 mat mat-height40 mat-input-style"
                          [placeholder]="'Select Department'"
                          [settings]="dropdownSettings"
                          [data]="getDepartmentsList"
                          (onSelect)="onDepartmentSelect()"
                          (onDeSelect)="onDepartmentDeSelect()"
                          (onSelectAll)="onDepartmentAllSelect()"
                          (onDeSelectAll)="onDepartmentAllDeSelect()">
                        </ng-multiselect-dropdown>
                      </ion-col>
                    
                    </ion-row>
        
                    <hr style="border: none; height: 1px; background-color: #cccccc8f;" />
                                    
                    <ion-row class="ion-align-items-center ion-justify-content-between ml-20">
        
                      <!-- Left: Search & Action Buttons -->
                      <ion-col size="12" size-lg="9">
                        <ion-row class="ion-align-items-center">
                    
                          <!-- Search -->
                          <ion-col size="12" size-sm="4" class="mb-16">
                            <mat-form-field class="mat-height40 mat-input-style w-100">
                              <mat-icon matPrefix>search</mat-icon>
                              <input matInput type="search" placeholder="Search" [(ngModel)]="searchTerm" (input)="filterEmployees()">
                            </mat-form-field>
                          </ion-col>
                    
                        
                    
                        </ion-row>
                      </ion-col>
                    
                      <!-- Right: Show Entries + Download -->
                      <ion-col size="12" size-lg="3" class="mb-16">
                        <div class="d-flex justify-content-end align-items-center" style="gap: 10px;">
                         
                          <label>
                            <ion-label class="fs-14 font_regular pr-10 black_color ml-10">Show</ion-label>
                            <mat-form-field class="w70px mat-height40 mat-input-style">
                              <mat-select placeholder="Select" (selectionChange)="DislaySelectedRecord($event)">
                                <mat-option [value]="2">2</mat-option>
                                <mat-option [value]="25">25</mat-option>
                                <mat-option [value]="50">50</mat-option>
                                <mat-option [value]="75">75</mat-option>
                                <mat-option [value]="100">100</mat-option>
                              </mat-select>
                            </mat-form-field>
                            <ion-label class="fs-14 font_regular pl-10 black_color">entries</ion-label>
                          </label>
                    
                          <!-- Download Icon -->
                          <span class="icon-download fs-20 material-icons" style="cursor: pointer;" (click)="downloadEmployeeList()">download</span>
                    
                        </div>
                      </ion-col>
                    
                    </ion-row>
                    
                    
                    <div class="p-10">
                      <ion-row>
                        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                      
                          <div class="table-container">
                            <table class="custom-table rounded-header">
                               <thead>
                                <tr>
                                  <ng-container *ngFor="let item of tableHeaders">
                                    <th *ngIf="!item.roles || item.roles.includes(loggedInUserRole)" class="fs-14 font_bold cl-black">
                                      <div class="verticle-center justify-content-space-between icon-style">
                                        {{ item?.label }}
                                      </div>
                                    </th>
                                  </ng-container>
                                </tr>              
                              </thead>
                                <tbody class="bg-white">
                                  <tr *ngFor="let program of trainingPrograms">
                                    
                                    <td>{{ program.trainingType }}</td>
                                    <td>{{ program.title }}</td>
                                    <td>{{ program.code }}</td>
                                    <td><a [href]="program.lmsLink" target="_blank">link</a></td>
                                    <td>{{ program.startDate }}</td>
                                    <td>{{ program.endDate }}</td>
                                    <td>{{ program.category }}</td>
                                    <td>{{ program.department }}</td>
                                    <td>{{ program.band }}</td>
                                    <td>{{ program.grade }}</td>
                                    <td>{{ program.programDays }}</td>
                                    <td *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin'">{{ program.budgetCost }}</td>
                                    <td   *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin'">{{ program.actualCost }}</td>
                                    <td>{{ program.objective }}</td>
                       
                                  </tr>
                                </tbody>
                            </table>
                          </div>
                        </ion-col>
                      </ion-row>
                    </div>
                  </div>              
                </div>      
            </div>        
            </div>
        
         
         







          <!-- ====================================================== Upcoming Training ======================================================== -->
          
          
          
          <div class="cardBox mb-20"  *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin'">
                <ion-row class="ion-align-items-center ion-justify-content-start ml-20 pt-20">

                  <!-- Year Select -->
                  <ion-col size="12" size-sm="3" class="mb-16">
                    <mat-form-field class="custom-mat-field mat-height40 mat-input-style w-100">
                      <mat-select placeholder="Select Year" [(ngModel)]="selectedYearForCompetency"
                                  (selectionChange)="getYearSetupForReimbursement(selectedYearForCompetency)">
                        <mat-option *ngFor="let item of pmsYears" [value]="item.year">
                          {{ sharedService.transformYearToFyFormat(item.year) }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ion-col>
                
                
                  <!-- Department Multi-select -->
                  <ion-col size="12" size-sm="3" class="mb-16">
                    <ng-multiselect-dropdown
                      class="w-100 mat mat-height40 mat-input-style"
                      [placeholder]="'Select Department'"
                      [settings]="dropdownSettings"
                      [data]="getDepartmentsList"
                      (onSelect)="onDepartmentSelect()"
                      (onDeSelect)="onDepartmentDeSelect()"
                      (onSelectAll)="onDepartmentAllSelect()"
                      (onDeSelectAll)="onDepartmentAllDeSelect()">
                    </ng-multiselect-dropdown>
                  </ion-col>
                
                </ion-row>

                <hr style="border: none; height: 1px; background-color: #cccccc8f;" />
                                
                <ion-row class="ion-align-items-center ion-justify-content-between ml-20">

                  <!-- Left: Search & Action Buttons -->
                  <ion-col size="12" size-lg="9">
                    <ion-row class="ion-align-items-center">
                
                      <!-- Search -->
                      <ion-col size="12" size-sm="4" class="mb-16">
                        <mat-form-field class="mat-height40 mat-input-style w-100">
                          <mat-icon matPrefix>search</mat-icon>
                          <input matInput type="search" placeholder="Search" [(ngModel)]="searchTerm" (input)="filterEmployees()">
                        </mat-form-field>
                      </ion-col>
                
                    
                
                    </ion-row>
                  </ion-col>
                
                  <!-- Right: Show Entries + Download -->
                  <ion-col size="12" size-lg="3" class="mb-16">
                    <div class="d-flex justify-content-end align-items-center" style="gap: 10px;">
                     
                      <label>
                        <ion-label class="fs-14 font_regular pr-10 black_color ml-10">Show</ion-label>
                        <mat-form-field class="w70px mat-height40 mat-input-style">
                          <mat-select placeholder="Select" (selectionChange)="DislaySelectedRecord($event)">
                            <mat-option [value]="2">2</mat-option>
                            <mat-option [value]="25">25</mat-option>
                            <mat-option [value]="50">50</mat-option>
                            <mat-option [value]="75">75</mat-option>
                            <mat-option [value]="100">100</mat-option>
                          </mat-select>
                        </mat-form-field>
                        <ion-label class="fs-14 font_regular pl-10 black_color">entries</ion-label>
                      </label>
                
                      <!-- Download Icon -->
                      <span class="icon-download fs-20 material-icons" style="cursor: pointer;" (click)="downloadEmployeeList()">download</span>
                
                    </div>
                  </ion-col>
                
                </ion-row>
                
                
                <div class="p-10">
                  <ion-row>
                    <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                  
                      <div class="table-container">
                        <table class="custom-table rounded-header">
                           <thead>
                            <tr>
                              <ng-container *ngFor="let item of tableHeaders">
                                <th *ngIf="!item.roles || item.roles.includes(loggedInUserRole)" class="fs-14 font_bold cl-black">
                                  <div class="verticle-center justify-content-space-between icon-style">
                                    {{ item?.label }}
                                  </div>
                                </th>
                              </ng-container>
                            </tr>              
                          </thead>
                            <tbody class="bg-white">
                              <tr *ngFor="let program of trainingPrograms">
                                
                                <td>{{ program.trainingType }}</td>
                                <td>{{ program.title }}</td>
                                <td>{{ program.code }}</td>
                                <td><a [href]="program.lmsLink" target="_blank">link</a></td>
                                <td>{{ program.startDate }}</td>
                                <td>{{ program.endDate }}</td>
                                <td>{{ program.category }}</td>
                                <td>{{ program.department }}</td>
                                <td>{{ program.band }}</td>
                                <td>{{ program.grade }}</td>
                                <td>{{ program.programDays }}</td>
                                <td >{{ program.budgetCost }}</td>
                                <td >{{ program.actualCost }}</td>
                                <td>{{ program.objective }}</td>
                   
                              </tr>
                            </tbody>
                        </table>
                      </div>
                    </ion-col>
                  </ion-row>
                </div>
              </div>
            